/**
 * @file   src\actions\chatHistory.js
 * @brief  This file is responsible for redux actions related to the
 *         full-page chat's conversation history sidebar
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  listChatConversations,
  getChatConversation,
  deleteChatConversation,
} from "../services/v2/chatHistoryService";

export const fetchChatConversations = createAsyncThunk(
  "chatHistory/fetchChatConversations",
  // conversationsVersion is captured at dispatch time and echoed back on the
  // fulfilled payload so the reducer can drop a response that raced a
  // removeChatConversation which has since landed - see
  // reducers/chatHistory.js's fulfilled case for why.
  async (_, { getState }) => {
    const conversationsVersion = getState().chatHistory.conversationsVersion;
    const response = await listChatConversations();
    return { ...response, conversationsVersion };
  },
);

export const fetchChatConversation = createAsyncThunk(
  "chatHistory/fetchChatConversation",
  (conversationId) => {
    return getChatConversation(conversationId);
  },
);

export const removeChatConversation = createAsyncThunk(
  "chatHistory/removeChatConversation",
  async (conversationId) => {
    await deleteChatConversation(conversationId);
    return conversationId;
  },
);
